// DO NOT CHANGE THE IDS, THEY ARE USED IN THE BACKEND
export const EQUIPMENT_TYPES = {
  ALL: 0,
  MACHINE: 1,
  TOOL: 2,
};
